<template>
  <div class="projectBill">
    <section class="bill-list">
      <div class="bill-item">
        <span class="label">服务费用：</span>
        <span class="value">￥{{costInfo.WorkLogTaxAmount | formatPrice}}</span>
      </div>
      <div class="bill-item">
        <span class="label">加班费用：</span>
        <span class="value">￥{{costInfo.OvertimeTaxAmount | formatPrice}}</span>
      </div>
      <div class="bill-item">
        <span class="label">交通费用：</span>
        <span class="value">￥{{costInfo.TrafficTaxAmount | formatPrice}}</span>
      </div>
      <div class="bill-item">
        <span class="label">住宿费用：</span>
        <span class="value">￥{{costInfo.HousingTaxAmount | formatPrice}}</span>
      </div>
      <div class="bill-item">
        <span class="label">其他费用：</span>
        <span class="value">￥{{costInfo.OtherTaxAmount | formatPrice}}</span>
      </div>
    </section>
    <div class="total">
      总计：<span class="count">￥{{costInfo.TrueTotalTaxAmount | formatPrice}}</span>
    </div>
    <section class="pay-node">
      <h3 class="sec-title">付款节点</h3>
      <div class="node-item" v-for="(item,index) in payList" :key="index">
        <div class="line-top">
          <span class="name">{{item.NoteTypeName }}</span>
          <span class="value price">¥{{item.Amount | formatPrice}}</span>
        </div>
        <div class="line-bottom">
          <time class="time">{{item.EndDate}}</time>
          <span class="btn-radius" v-if="item.IsCanPay" @click="pay(item)">支付</span>
          <span class="status" v-else>{{item.PayStatusName}}</span>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { 
  GetSenderJobAmountNodeList,
  CreatePayOrder,
  JobAmountRefund
} from "@/scripts/api.js";
export default {
  name:'projectBill',
  data(){
    return{
      costInfo:{},
      payList:[],
    }
  },
  created() {
    this.pageInit();
  },
  methods: {
    pageInit(){
      GetSenderJobAmountNodeList({
        JobId:this.$route.query.jobId
      }).then(r=>{
        if(r.Result==1){
          this.costInfo=r.Data.AmountInfo || {};
          this.payList=r.Data.PaymentNodeList || [];
        }
      })
    },
    pay(item){
      let params = {
        OuterOrderType: 1,
        OuterOrderId: this.$route.query.jobId,
        TradeType: 4, //1：B2B平台，2：自由平台，3：追加押金，4:项目工单
        JobAmountNoteId:item.Id,
      };
      CreatePayOrder(params).then(r => {
        if (r.Result == 1) {
          
          if(r.Data.IsGoPay){
            this.$router.push({
                path:'/payment',
                query:{
                    payId:r.Data.PayId 
                }
            })
            // window.open(r.Data.PcPayUrl,'_blank');
            // window.open(r.Data.PcPayUrl,'_self');
          }else{
            let that=this;
            this.$password({
              async onConfirm (data){
                //退款接口
                await JobAmountRefund({
                  PayId:r.Data.PayId,
                  JobAmountNoteId:item.Id,
                  PayPwd:data 
                }).then(r=>{
                  that.$toast(r.Message);
                  if(r.Result==1){
                    console.log(r)
                    // that.$emit('init')
                    that.pageInit();
                  }
                })
                this.close();
              },
              onCancel(){
                this.close();
                that.$router.push('/center/accountProtect');
              }
            })
          }
        } else {
          this.$toast(r.Message);
        }
      });
    }
  },
}
</script>
<style lang="scss">
.projectBill{
  padding-top: 30px;
  padding-bottom: 60px;
  width: 840px;
  .bill-list{
    background-color: #f9f9f9;
    padding: 14px 18px;
    margin-bottom: 20px;
    .bill-item{
      margin-bottom: 10px;
      line-height: 24px;
      color: #333;
      overflow: hidden;
      &:last-child{
        margin-bottom: 0;
      }
    }
    .label{
      font-size: 14px;
      float: left;
    }
    .value{
      font-size: 14px;
      font-family: 'DIN-Regular';
      float: right;
      font-weight: bold;
    }
  }
  .total{
    font-size: 16px;
    color: #333;
    line-height: 30px;
    text-align: right;
    .count{
      font-size: 24px;
      font-family: 'DIN-Regular';
      color: #f75959;
      font-weight: bold;
    }
  }
  .pay-node{
    margin-top: 20px;
    .sec-title{
      font-size: 24px;
      line-height: 36px;
      color: #333;
      margin-bottom: 20px;
    }
  }
  .node-item{
    background-color: #f9f9f9;
    padding: 10px 18px;
    line-height: 32px;
    margin-bottom: 20px;
    .line-top{
      overflow: hidden;
      margin-bottom: 10px;
    }
    .name{
      font-size: 18px;
      color: #333;
      font-weight: bold;
      float: left;
    }
    .value{
      font-size: 20px;
      font-family: 'DIN-Regular';
      color: #333;
      font-weight: bold;
      float: right;
      &.price{
        color: #f75959;
      }
    }
    .line-bottom{
      overflow: hidden;
    }
    .time{
      font-size: 14px;
      color: #333;
      float: left;
    }
    .status{
      font-size: 18px;
      color: #333;
      font-weight: bold;
      float: right;
    }
    .btn-radius{
      width: 80px;
      height: 32px;
      float: right;
      border-radius: 32px;
      text-align: center;
      line-height: 32px;
      font-size: 14px;
      color: #fff;
      background-color: #f75959;
      cursor: pointer;
    }
  }
}
</style>